export default __webpack_public_path__ + "static/media/ExcelSvgIcon.5eb9b455.svg";